var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgFilledFeedbackError = function SvgFilledFeedbackError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 98,
    viewBox: "0 0 192 98",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 9,
    width: 80,
    height: 80,
    rx: 24,
    fill: "#FFEAEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.47 29c1.539-2.667 5.388-2.667 6.928 0l19.052 33c1.54 2.667-.385 6-3.464 6H76.881c-3.08 0-5.004-3.333-3.464-6l19.052-33zm3.463 2L76.881 64h38.105L95.933 31z",
    fill: "#DD0048"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96 41a2 2 0 012 2v8a2 2 0 01-4 0v-8a2 2 0 012-2zm-2 18a2 2 0 012-2h.02a2 2 0 110 4H96a2 2 0 01-2-2z",
    fill: "#DD0048"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkyIiBoZWlnaHQ9Ijk4IiB2aWV3Qm94PSIwIDAgMTkyIDk4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB4PSI1NiIgeT0iOSIgd2lkdGg9IjgwIiBoZWlnaHQ9IjgwIiByeD0iMjQiIGZpbGw9IiNGRkVBRUMiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05Mi40Njk0IDI5Qzk0LjAwOSAyNi4zMzMzIDk3Ljg1OCAyNi4zMzMzIDk5LjM5NzYgMjlMMTE4LjQ1IDYyQzExOS45OSA2NC42NjY3IDExOC4wNjUgNjggMTE0Ljk4NiA2OEg3Ni44ODFDNzMuODAxOCA2OCA3MS44NzczIDY0LjY2NjcgNzMuNDE2OSA2Mkw5Mi40Njk0IDI5Wk05NS45MzM1IDMxTDc2Ljg4MSA2NEwxMTQuOTg2IDY0TDk1LjkzMzUgMzFaIiBmaWxsPSIjREQwMDQ4Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOTUuOTk5NSA0MUM5Ny4xMDQxIDQxIDk3Ljk5OTUgNDEuODk1NCA5Ny45OTk1IDQzVjUxQzk3Ljk5OTUgNTIuMTA0NSA5Ny4xMDQxIDUzIDk1Ljk5OTUgNTNDOTQuODk0OSA1MyA5My45OTk1IDUyLjEwNDUgOTMuOTk5NSA1MVY0M0M5My45OTk1IDQxLjg5NTQgOTQuODk0OSA0MSA5NS45OTk1IDQxWk05My45OTk1IDU5QzkzLjk5OTUgNTcuODk1NCA5NC44OTQ5IDU3IDk1Ljk5OTUgNTdIOTYuMDE5NUM5Ny4xMjQxIDU3IDk4LjAxOTUgNTcuODk1NCA5OC4wMTk1IDU5Qzk4LjAxOTUgNjAuMTA0NSA5Ny4xMjQxIDYxIDk2LjAxOTUgNjFIOTUuOTk5NUM5NC44OTQ5IDYxIDkzLjk5OTUgNjAuMTA0NSA5My45OTk1IDU5WiIgZmlsbD0iI0REMDA0OCIvPgo8L3N2Zz4K";
export { SvgFilledFeedbackError as ReactComponent };